<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 动态按钮生成 -->
    <div class="content_edit">
      <pre-button @button-event="select_method" :pre_control="control" />
      <div class="content_btn">
        <div class="content_btn_item">
          <slot name="pre_base_button"></slot>
          <button @click="look_note">备注说明</button>
        </div>
      </div>
    </div>
    <!-- 动态编辑区生成 -->
    <div class="content_edit">
      <div class="content_edit_item" v-for="(item,index) in parm" :key="index">
        <div v-if="item.type === 'text'">
          <label>{{item.name}}:</label>
          <input type="text" :class="[item.class==''?'long1':item.class]" v-model="item.val" @keyup.enter="go_save" />
          <em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
        </div>
        <div v-else-if="item.type === 'number'">
          <label>{{item.name}}:</label><input type="number" class="long1" v-model="item.val" @keyup.enter="go_save" />
        </div>
        <div v-else-if="item.type === 'date'">
          <label>{{item.name}}:</label>
          <el-date-picker type="date" :class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
            v-model="item.val" placeholder="选择日期">
          </el-date-picker>
          <em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
        </div>
        <div v-else-if="item.type === 'select'">
          <label>{{item.name}}:</label><input type="text" :class="[item.class==''?'long1':item.class]"
            v-model="item.sel_name" @keyup.enter="go_save" @keyup="select_change(item)" />
          <slot :name="item.slot"></slot>
          <em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
        </div>
        <div v-else-if="item.type === 'none'">
          <input type="text" v-show="false" v-model="item.val" />
        </div>
        <div v-else-if="item.type == 'readonly'">
          <label>{{item.name}}:</label><input type="text" :class="[item.class==''?'short0':item.class]"
            v-model="item.val" readonly="readonly" />
        </div>
        <div v-else-if="item.type === 'radio'">
          <el-radio-group v-model="radio" size="mini" @change="fun_option(item)">
            <el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id" border>{{d.name}}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div v-show="show_file" class="content_edit_item">
        <label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
      </div>
    </div>

    <!-- 通配表格设置 -->
    <pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
      :pre_post_upd="upd_json">
      <!-- 设定标题  -->
      <template slot="tab_title">
        <tr class="tab_header" :class="[isNone=='1'?TwoNone:OneNone]">
          <td>ID</td>
          <td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
        </tr>
      </template>
      <template slot="tab_tr" slot-scope="user">
        <tr :id="'m_'+user.item[1].val"  :class="[isNone=='1'?TwoNone:OneNone]" @click="sel_row(user.item)" @dblclick="sel_show_detail(user.item)">
          <!-- <a href="#"> -->
          <td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
            v-on:mouseout="noshow_detaildata"><a href="#">{{d.val}}</a></td>
          <!-- </a> -->
        </tr>
      </template>
      <!-- 构建新增模板 -->
      <template slot="tab_addorupdate">

      </template>
    </pre-table>

    <!-- 通用导出excel -->
    <per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
      v-bind:pre_postjson="postjson1" :clicktype="'down1'">
      <template slot="tab_excelup_title">
        <tr>
          <th>ID</th>
          <th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
        </tr>
      </template>
      <template slot="tab_excelup_tr" slot-scope="user">
        <tr @click="sel_row(user.item)">
          <td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
        </tr>
      </template>
    </per-exceldown>

    <!-- 明细数据提示 -->
    <div id="pre_detail_data" style="display:none;">
      <p v-for="(item, index) in detail_data" :key="index">
        {{ item.name }}={{ item.amount }}
      </p>
    </div>
    <div id="pre_msg_data" style="display:none;"></div>

    <!-- 文件预览部分 -->
    <!-- 弹出向导层 预览 与 下载 start-->
    <!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
    <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

    <a id="downlink"></a>
    <a id="loodlink" target="_blank"></a>

  </div>
</template>

<script>
  /*
名称：通用基础模板2.0
日期：2020-11-30
作者：hj
目标：
方法 传入参数，
1、动态获取操作权限
2、全部操作同步完成。无需二次修改。
3、如果由默认值，需要实现默认查询。
4、分页支持，主单据文件操作支持。必须5个字段内容

5、无明细内容

*/

  import api from '@/utils/type.js';
  import {
    Method_DataByPage,
    Method_Common
  } from '@/utils/loadhttpdata.js';

  // 文件操作辅助方法
  import {
    base_encode
  } from "@/utils/base64.js";
  import {
    GetShort,
    DeleteSpecialWord,
    BackSpecial,
    ChangeSpecial,
    GetRandom
  } from "@/utils/localstore.js";
  import {
    BrowserGet
  } from '@/utils/systemSelect.js';

  export default {
    name: "pre_base_2",
    components: {
      "pre-button": () => import("./pre_btn_control.vue"),
      "pre-table": () => import("./pre_table_nokey2.vue"),
      'per-exceldown': () => import("./pre_excel_down.vue")
    },
    data() {
      return {
        element_loading: false,
        control: '',
        load_url: '',
        load_json: '',
        upd_json: '',
        bak_data: '', //防止重复操作记录
        nowpage: '1',
        title: '未设置标题',
        sel_action: '',
        upd_action: '',
        row_id: '',
        sel_item: [], //备份点击项目
        sys_date: '',
        // 审核标记
        flag: '',

        parm: [], //参数结构
        parm_th: [], //标题
        kw1: '',
        kw2: '',
        kw3: '',
        kw4: '',

        // excel
        show_excel: false,
        postjson1: {},
        // radio
        radio: '1',

        // 备注
        detail_data: '',
        //文件
        show_file: false,
        file_name: "",
        file_data: "",
        file_up: "",
        file_url: "",
        file_src: "",
        file_action: '',
        blockSize: '',
        file_backdata: '',
        p1: '',
        p2: '',
        p3: '',

        // 定义默认样式
        isNone:'',
        TwoNone:'last-two-none',
        OneNone:'last-one-none',

      };
    },
    props: {
      pre_data: {
        type: String,
        default: ''
      }
    },
    watch: {
      pre_data(val) {
        if (val.length > 0) {
          this.load_data();
        }
      }
    },
    mounted: function() {
      if (this.pre_data != '') {
        let that = this;
        this.$nextTick(function() {
          this.load_data();
        });
      }
    },
    methods: {
      load_data: function() {
        // console.log(this.pre_data);
        let r = JSON.parse(this.pre_data);
        // console.log(r);
        let that = this;
        this.$nextTick(function() {
          that.control = r.control;
          that.sel_action = r.sel_action;
          that.upd_action = r.upd_action;

          that.isNone = r.isNone;

          that.file_action = r.file_action;
          that.p1 = r.p1;
          that.p2 = r.p2;
          that.p3 = r.p3;
          that.kw1 = r.keyword;
          that.parm = r.parm;
          that.parm_th = r.parm_th;
          // console.log(this.parm);

          that.refresh_data();
        });
      },
      look_note: function() {
        //收缩区 收放设置
        this.show_note = this.show_note ? false : true;
        if (this.show_note) {
          $("#notice").slideDown("slow");
        } else {
          $("#notice").slideUp("slow");
        }
      },
      select_method: function(type) {
        // console.log(type);
        // if (type != 'add' && type != 'sel' && type != 'new' && type != 'exl' && Number(this.row_id) == 0) {
        //   this.$message.error('请先选择要编辑的数据!');
        //   return;
        // }
        switch (type) {
          case 'new':
            this.data_clear();
            break;
          case 'add':
            // 不能在方法里传  this.变量
            this.fun_upd('_add');
            break;
          case 'upd':
            this.fun_upd('_upd');
            break;
          case 'del':

            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.fun_upd('_del');
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
            break;
          case 'sel':
            this.refresh_data('select');
            break;
          case 'sub':
            this.fun_upd('_sub');
            break;
          case 'bad':
            this.fun_upd('_bad');
            break;
          case 'exl':
            this.build_exceldata();
            break;
          case 'filesel':
            this.fun_sel_file();
            break;
          case 'fileup':
            this.fun_up_file();
            break;
          case 'filelook':
            this.fun_look_file();
            break;
          case 'filedel':
            this.fun_del_file();
            break;
          default:
            this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
            break;
        }
      },
      refresh_data: function(type, page, backdata) {
        // console.log(backdata);
        let back = null;
        if (typeof(backdata) != "undefined" && backdata != '') {
          back = JSON.parse(backdata);
          // console.log(back);
          // console.log('new_id=' + back.new_id);
          this.row_id = back.new_id;
          this.sys_date = back.keyword.sys_date;
          for (let j = 0; j < this.parm.length; j++) {
            if (this.parm[j].key == 'sheet_no') {
              this.parm[j].val = back.keyword.sheet_no;
              this.sheet_no = back.keyword.sheet_no;
              break;
            }
          }
        }

        // console.log('type='+type);


        if (typeof(type) != 'undefined') {
          for (let i = 0; i < this.parm.length; i++) {
            switch (this.parm[i].sel) {
              case '1':
                this.kw1 = this.parm[i].val;
                break;
              case '2':
                this.kw2 = this.parm[i].val;
                break;
              case '3':
                this.kw3 = this.parm[i].val;
              case '4':
                this.kw4 = this.parm[i].val;
              case '5':
                this.kw5 = this.parm[i].val;
                break;
            }
          }
        }

        let r = (Math.random() + '').substring(0, 8);
        // console.log('刷新=' + type + ' page=' + page);
        if (Number(page) > 0) {
          this.nowpage = page;
        }

        if (typeof(type) != "undefined" && type != '') {
          this.kw4 = type;
        }

        this.load_url = api.http_method;
        this.load_json = Method_DataByPage('data_' + this.sel_action, this.nowpage, this.kw1, this.kw2, this.kw3,
          this.kw4, this.kw5, r);

      },
      sel_row: function(item) {
        // console.log(item);
        // 判断 obj.hasOwnProperty("key")
        //2、遍历Json串获取其属性
        this.data_clear();
        for (let i = 0; i < item.length; i++) {
          if (item[i].key == 'id') {
            this.row_id = item[i].val;
          } else if (item[i].key == 'sys_date') {
            this.sys_date = item[i].val;
          } else if (item[i].key == 'f_url') {
            let tt = BackSpecial(item[i].val);
            tt = tt.substring(tt.lastIndexOf('/') + 1);
            this.file_name = BackSpecial(BackSpecial(tt));
            this.file_url = item[i].val;
            this.show_file = true;
          } else if (item[i].key == 'f_src') {
            this.file_src = item[i].val;
          } else if (item[i].key == 'flag') {
            this.flag = item[i].val;
          } else {
            for (let j = 0; j < this.parm.length; j++) {
              if (this.parm[j].type == 'select' && this.parm[j].key == item[i].key) {
                this.$emit('base2-event', this.parm[j].slot, item[i].val)
                break;
              } else if (this.parm[j].type == 'radio' && this.parm[j].key == item[i].key) {
                if (item[i].val == '是') {
                  this.radio = '1';
                } else {
                  this.radio = '0';
                }
                // console.log(this.radio);
                this.parm[j].val = this.radio;
              } else {
                if (this.parm[j].key == item[i].key) {
                  this.parm[j].val = item[i].val;
                  break;
                }
              }
            }
          }
        }
        // 给父组件传点的 row_id，
        this.$emit('base2-event', '', this.row_id, item);

        // 切换背景色
        this.$refs.file_table.setCurrentRowJson('m_', item[1].val);
      },
      sel_show_detail: function(item) {
        // console.log('双击.........');
        for (let i = 0; i < item.length; i++) {
          if (item[i].key == 'id') {
            this.row_id = item[i].val;
            break;
          }
        }
        this.$emit('base2-event', 'showdetail', this.row_id, item);
      },
      refesh_parm: function(type, id, val) {
        // 刷新select菜单参数
        // console.log('组件type=' + type + ' val=' + val)
        for (let j = 0; j < this.parm.length; j++) {
          if (this.parm[j].slot == type) {
            this.parm[j].sel_name = val;
            this.parm[j].val = id;
            break;
          }
        }
      },
      fun_option: function(item) {
        // 单选项 参数传值。
        for (let j = 0; j < this.parm.length; j++) {
          if (this.parm[j].type == 'radio' && this.parm[j].key == item.key) {
            this.parm[j].val = this.radio;
            break;
          }
        }
      },
      data_clear: function() {
        this.bak_data = ''; //防止重复操作记录

        this.row_id = '';
        this.sel_item = {}; //备份点击项目
        // 文件名称、路径、储存 选择确定
        this.show_file = false;
        this.file_name = '';
        this.file_url = '';
        this.file_src = '';

        for (let j = 0; j < this.parm.length; j++) {
          if (this.parm[j].type == 'select') {
            this.parm[j].val = '';
            this.parm[j].sel_name = '';
            this.$emit('base2-event', this.parm[j].slot, 'clear')
          } else {
            this.parm[j].val = '';
          }
        }
      },
      go_save: function() {

        this.fun_upd('_add');
      },
      select_change: function(item) {
        let that = this;
        that.$emit('base2-event', item.slot, item.sel_name)
      },
      fun_upd: function(type) {
        // console.log('操作类型=' + type + ' row_id=' + this.row_id);
        if (type == '_upd') {
          if (this.row_id == 0) {
            this.$message({
              message: '请选择要修改的数据!',
              type: 'warning'
            });
            return;
          }
        }


        let d = [];
        for (let i = 0; i < this.parm.length; i++) {
          // console.log(this.parm[i].val);
          d.push(this.parm[i].val);
        }
        // console.log(d);
        let temp_data = '';
        temp_data = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d);
        if (this.bak_data == temp_data) {
          this.$message({
            message: '不能重复操作!',
            type: 'warning'
          });
          return;
        }
        this.upd_json = temp_data;
        this.bak_data = temp_data;
      },
      show_detaildata: function(that, item, type) {
        var x = 0,
          y = 0,
          temp_css = '';
        // console.log('明细数据显示坐标 ' + x + ' ' + y);
        // console.log(item);
        x = that.clientX + 10;
        y = that.clientY;
        temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
          "px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
        if (type == "0" && item.detail_data.length > 0) {
          this.detail_data = item.detail_data;
          // console.log($('#pre_detail_data'));
          document.getElementById("pre_detail_data").style.cssText = temp_css;
        }
        if (type == "1" && item != '') {
          temp_css += "max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
          document.getElementById("pre_msg_data").innerText = BackSpecial(item);
          document.getElementById("pre_msg_data").style.cssText = temp_css;
        }
      },
      noshow_detaildata: function() {
        // console.log('不显示明细');
        document.getElementById("pre_detail_data").style.display = 'none';
        document.getElementById("pre_msg_data").style.display = 'none';
      },
      build_exceldata: function(type) {
        // 不做分页
        if (type == 'close') {
          this.show_excel = false;
        } else {
          if (this.parm.length > 0) {
            this.kw1 = this.parm[0].val;
          }

          this.postjson1 = Object.assign({}, this.postjson1, {
            type: 'down1',
            url: api.http_method,
            post: Method_DataByPage('data_' + this.sel_action, 99999999, this.kw1, this.kw2, this.kw3,
              this.kw4, this.kw5)
          });

          this.show_excel = true;
        }
      },
      //附件操作 start //////////////////////////////////////
      // 点击上传附件
      fun_sel_file: function() {

        // console.log('点击选择附件=' + this.row_id);
        if (this.row_id == null || Number(this.row_id) == 0) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 单据名称=' + this.file_name + '</div>请检查!'
          });
          return;
        }
        console.log(this.file_url);
        if (this.file_url != '') {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
          });
          return;
        }

        this.file_name = '';
        this.file_data = '';
        this.file_up = '';
        let fileobj = document.getElementById('hetong_file');
        fileobj.click();
      },
      fun_look_file: function() {
        console.log('点击预览附件');
        if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
          });
          return;
        }

        if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
          // 会被火狐浏览器弹窗阻止,360和谷歌正常
          this.pdfview = document.getElementById('loodlink');
          this.pdfview.href = this.file_url;
          // window.open(tv_url, '_blank'); //被弹窗阻止
          this.pdfview.click();
        } else {
          this.$message({
            message: '该类型文件暂不支持预览,将开始下载!',
            type: 'success'
          });


          let down_file = document.getElementById("downlink");
          let temp_url = BackSpecial(this.file_url);
          let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
          down_file.download = '测试'; // 下载名称
          down_file.href = temp_url; // 绑定a标签
          down_file.click(); // 模拟点击实现下载
        }
      },
      getFilePath: function() {
        let tmpFile = document.getElementById('hetong_file');
        // console.log('点击选择结果');
        // console.log(tmpFile.files);
        if (typeof FileReader !== "undefined") {
          let max_size = 100000; // 50k 20M
          let name = '';
          let size = 0;
          let fileData = tmpFile.files[0];
          this.file_backdata = fileData;
          name = fileData.name;
          size = fileData.size;
          console.log('名称=' + name + ' 大小=' + size);
          if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
            this.$message({
              message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
              type: 'warning'
            });
            return;
          }
          this.file_name = name;
          if (size > max_size * 1024) {
            this.$message({
              message: '图片大小不能超过2M',
              type: 'warning'
            });
            return
          }
          // console.log(tmpFile);   //连标签原样输出了
          // console.log(tmpFile.value);   //图片路径

          let reader = new FileReader(); // FileReader
          let that = this;
          reader.readAsDataURL(fileData);
          reader.onload = function() {
            // 获取到base64图片内容
            that.file_data = this.result;
          }
          // console.log(size / 1024 + 'kB');
        } else {
          this.$message({
            message: '当前浏览器不支持上传组件',
            type: 'warning'
          });
        }

      },
      fun_del_file: function() {
        console.log('点击删除附件');
        if (this.flag == '完成' || this.flag == '已提交') {
          this.$message({
            message: '单据已经完成,不能删除附件!',
            type: 'warning'
          });
          return;
        }

        if (this.file_url == '') {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
          });
          return;
        }
        // 第一步 删除存储路径
        this.fun_del_file_two();
        // 第二步 删除真实文件
        this.fun_del_file_three(this.file_src);
      },
      fun_del_file_two: function() {
        var postdata = "";
        postdata =
          '{"action":"' + 'data_del_' + this.file_action + '","user_no":"' +
          GetShort("userno") +
          '","sheet_no":"' +
          this.sheet_no +
          '","rowid":"' +
          this.row_id +
          '"}';

        // console.log(postdata);
        postdata =
          '{"method":"File_load","data":"' + base_encode(postdata) + '"}';

        this.$post(
          api.http_method, postdata
        ).then(res => {
          res = JSON.parse(res);
          // console.log(res);
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
        });

      },
      fun_del_file_three: function() {
        // console.log('删除路径 \r\n' + this.file_src);
        var postdata = '';
        postdata =
          '{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
        this.$post(
          api.http_method, postdata
        ).then(res => {

          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {

            this.$message({
              message: BackSpecial(BackSpecial(res.data.msg)),
              type: 'success'
            });

          } else {
            this.$message({
              message: BackSpecial(BackSpecial(res.data.msg)),
              type: 'warning'
            });
          }
        });
      },
      fun_up_file: async function() {
        // 一块文件的大小
        this.blockSize = 1 * 1024 * 1024;
        // console.log('base64文件大小=' + this.file_data.length)
        if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
          // console.log('小文件上传');
          this.fun_up_file_min();
        } else if (this.file_data.length > this.blockSize) {
          // console.log('大文件上传');
          // this.element_loading = true;
          let random_name = GetRandom();
          this.file_name = random_name + this.file_name;

          await this.fun_up_file_max();
          // this.element_loading = false;
        } else {
          this.$message({
            message: '未发现上传文件!',
            type: 'warning'
          });
        }
      },
      fun_up_file_min: function() {


        // console.log('点击上传附件');
        if (this.p3 == '') {
          this.p3 = GetShort("userno");
        }
        // console.log('p3=' + this.p3);
        this.element_loading = true;
        var postdata = "";
        postdata =
          '{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
          GetShort("userno") +
          '","upfile_name":"' +
          DeleteSpecialWord(this.file_name) +
          // '","upfile_type":"' +
          // this.file_type +
          // '","upfile_size":"' +
          // this.file_size +
          '","upfile_data":"' +
          this.file_data +
          '","rowid":"' +
          this.row_id +
          '","sheet_no":"' +
          this.sheet_no +
          '","p1":"' +
          this.p1 +
          '","p2":"' +
          this.p2 +
          '","p3":"' +
          this.p3 +
          '"}';
        postdata =
          '{"method":"File_load","data":"' + base_encode(postdata) + '"}';


        let that = this;
        var loaded = 0,
          total = 0;
        this.$postfile(
          api.http_method,
          postdata,
          res => {
            loaded = res.loaded;
            total = res.total;
            this.$nextTick(() => {
              that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
            });
          }
        ).then(res => {
          res = JSON.parse(res);
          res = res.data;
          this.element_loading = false;
          if (res.status == 1) {
            that.file_up = "上传成功";

            that.file_url = BackSpecial(res.f_url);
            that.file_src = BackSpecial(res.f_src);

            that.refresh_data();

            this.$message({
              message: '上传成功',
              type: 'success'
            });
          } else {
            this.file_up = "上传失败";

            this.$message({
              message: '上传失败\n\r' + res.msg,
              type: 'success'
            });
          }

        });


      },
      fun_up_file_max: async function() {
        // 大于1M，分段上传
        let num = 1;
        let start = 0;
        let end = 0;
        let maxFileLength = 0;
        maxFileLength = this.file_backdata.size;
        // console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

        while (start < maxFileLength) {
          end = start + this.blockSize;
          if (end > maxFileLength) {
            end = maxFileLength;
          }


          let temp_data = '';
          temp_data = this.file_backdata.slice(start, end); //文件切片
          // console.log('上传长度=' + temp_data.size);
          // console.log(temp_data);
          // 上传出错则重新上传
          let res = '';
          try {
            res = await this.fun_up_file_block(temp_data);
            console.log(res);
            if (res.status == 1) {
              this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) + " %";
            } else {
              // let maxTime = 3;
              // let min = 0
              // let resTwo = '';
              // while (min < maxTime) {
              //   resTwo = await this.fun_up_file_block(temp_data);
              //   if (resTwo.status != 1) {
              //     this.$message({
              //       message: '上传出错请稍后重新上传',
              //       type: 'success'
              //     });
              //   }
              //   min++;
              // }

            }
          } catch (error) {
            res = await this.fun_up_file_block(temp_data);
          }
          start = end;
          num++;
        }

        this.fun_up_file_savepath();
      },
      fun_up_file_block: async function(temp_data) {
        // console.log('点击上传附件');
        if (this.p3 == '') {
          this.p3 = GetShort("userno");
        }
        // console.log('p3=' + this.p3);
        let that = this;
        var postdata = "";
        // postdata = {
        //   "action": 'data_save_' + that.file_action,
        //   'user_no': that.user_no,
        //   "p1": that.p1,
        //   "p2": that.p2,
        //   "p3": that.p3,
        //   "row_id": that.row_id,
        //   "sheet_no": that.key_word
        // };
        let temp_filedata = await this.fun_blod_toString(temp_data);

        postdata =
          '{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
          GetShort("userno") +
          '","upfile_name":"' +
          DeleteSpecialWord(this.file_name) +
          // '","upfile_type":"' +
          // this.file_type +
          // '","upfile_size":"' +
          // this.file_size +
          '","upfile_data":"' +
          temp_filedata +
          '","rowid":"' +
          this.row_id +
          '","sheet_no":"' +
          this.sheet_no +
          '","p1":"' +
          this.p1 +
          '","p2":"' +
          this.p2 +
          '","p3":"' +
          this.p3 +
          '"}';
        postdata =
          '{"method":"File_block","data":"' + base_encode(postdata) + '"}';

        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method, postdata
          ).then(res => {
            res = JSON.parse(res);
            // console.log(res);

            resolve(res.data)
          })
        });

      },
      fun_blod_toString: function(fileData) {
        return new Promise((resolve, reject) => {

          let reader = new FileReader(); // FileReader
          reader.readAsDataURL(fileData);
          reader.onload = function() {
            // 获取到base64图片内容
            // console.log(this.result);
            // let f='';
            // f=ChangeSpecial(this.result);
            // console.log(f);
            resolve(this.result);
          }

        });
      },
      fun_up_file_savepath: function() {
        if (this.p3 == '') {
          this.p3 = GetShort("userno");
        }
        console.log('p3=' + this.p3);
        this.element_loading = true;
        var postdata = "";
        postdata =
          '{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
          GetShort("userno") +
          '","upfile_name":"' +
          DeleteSpecialWord(this.file_name) +
          // '","upfile_type":"' +
          // this.file_type +
          '","upfile_path":"' +
          this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
          '","upfile_data":"' +
          '' +
          '","rowid":"' +
          this.row_id +
          '","sheet_no":"' +
          this.sheet_no +
          '"}';

        // console.log(postdata);
        postdata =
          '{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


        let that = this;
        this.$post(
          api.http_method,
          postdata
        ).then(res => {
          res = JSON.parse(res);
          res = res.data;
          this.element_loading = false;
          if (res.status == 1) {
            that.file_up = "上传成功";

            that.file_url = BackSpecial(res.f_url);
            that.file_src = BackSpecial(res.f_src);

            that.refresh_data();

            this.$message({
              message: '上传成功',
              type: 'success'
            });
          } else {
            this.file_up = "上传失败";

            this.$message({
              message: '上传失败\n\r' + res.msg,
              type: 'success'
            });
          }

        });

      },




    }
  };
</script>


<style scoped>
  .last-two-none>td:nth-last-child(3),
  .last-two-none>td:nth-last-child(2) {
    display: none;
  }

  .last-two-none>td:nth-last-child(2) {
    display: none;
  }


</style>
